/**
 *  @class
 *  @function EditorialEscalera
 */
if (!customElements.get('editorial-escalera')) {
  class EditorialEscalera extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.container = this.querySelector('.editorial-escalera__row');
      this.inners = Array.from(this.querySelectorAll('.editorial-escalera__inner'));
      if (!this.container || !this.inners.length || typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.setupScroll();
      this.observeVisibility();
    }
    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.tl?.scrollTrigger?.kill();
      this.tl?.kill();
    }
    observeVisibility() {
      if (typeof ResizeObserver === 'undefined') return;
      this.wasVisible = this.offsetParent !== null;
      this.resizeObserver = new ResizeObserver(() => {
        let visible = this.offsetParent !== null;
        if (visible && !this.wasVisible) ScrollTrigger.refresh();
        this.wasVisible = visible;
      });
      this.resizeObserver.observe(this);
    }
    setupScroll() {
      let isMobile = window.matchMedia('(max-width: 767px)').matches;
      let stepHeight = parseInt(isMobile ? this.dataset.stepHeightMobile : this.dataset.stepHeight, 10) || 400;
      let riseOffset = window.innerHeight;

      let order = this.inners.slice();
      if (this.dataset.direction === 'right_to_left') order.reverse();

      let animated = order.slice(1);
      if (!animated.length) return;

      this.classList.add('is-animated');
      gsap.set(animated, { y: riseOffset });

      this.tl = gsap.timeline({
        scrollTrigger: {
          trigger: this.container,
          start: 'center center',
          end: () => `+=${animated.length * stepHeight}`,
          pin: true,
          scrub: 0.5,
          invalidateOnRefresh: true,
          anticipatePin: 1,
        }
      });

      animated.forEach((el, i) => {
        this.tl.to(el, { y: 0, ease: 'power1.out', duration: 1 }, i);
      });
    }
  }
  customElements.define('editorial-escalera', EditorialEscalera);
}

if (!window.__editorialEscaleraAnchorScroll) {
  window.__editorialEscaleraAnchorScroll = true;
  document.addEventListener('click', function (e) {
    let link = e.target.closest('.editorial-escalera a[href^="#"]');
    if (!link) return;
    let id = link.getAttribute('href').slice(1);
    let target = id && document.getElementById(id);
    if (!target) return;
    e.preventDefault();
    let headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'), 10) || 0;
    let top = target.getBoundingClientRect().top + window.scrollY - headerHeight;
    window.scrollTo({ top: top, behavior: 'smooth' });
  });
}
